'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO NOPEPARTS - Nelze AbstractField / addony
var CheckboxField = function (_AbstractField) {
    (0, _inherits3.default)(CheckboxField, _AbstractField);

    function CheckboxField() {
        (0, _classCallCheck3.default)(this, CheckboxField);
        return (0, _possibleConstructorReturn3.default)(this, (CheckboxField.__proto__ || (0, _getPrototypeOf2.default)(CheckboxField)).apply(this, arguments));
    }

    (0, _createClass3.default)(CheckboxField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                disabled = _props.disabled,
                addonsBefore = _props.addonsBefore,
                value = _props.value,
                addonsAfter = _props.addonsAfter,
                onClick = _props.onClick,
                props = (0, _objectWithoutProperties3.default)(_props, ['label', 'disabled', 'addonsBefore', 'value', 'addonsAfter', 'onClick']);


            var field = void 0;
            if (label) {
                field = _react2.default.createElement(
                    _reactstrap.Label,
                    { check: true, className: disabled ? "disabled" : "", onClick: onClick },
                    _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({ type: 'checkbox', disabled: disabled, checked: value, onClick: onClick }, props)),
                    '\xA0',
                    label
                );
            } else {
                field = _react2.default.createElement(
                    _reactstrap.Label,
                    { check: true, className: disabled ? "disabled" : "", onClick: onClick },
                    _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({ type: 'checkbox', disabled: disabled, checked: value, onClick: onClick }, props))
                );
            }

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return CheckboxField;
}(_AbstractField3.default);

exports.default = CheckboxField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvQ2hlY2tib3hGaWVsZC5qc3giXSwibmFtZXMiOlsiQ2hlY2tib3hGaWVsZCIsInByb3BzIiwibGFiZWwiLCJkaXNhYmxlZCIsImFkZG9uc0JlZm9yZSIsInZhbHVlIiwiYWRkb25zQWZ0ZXIiLCJvbkNsaWNrIiwiZmllbGQiLCJyZW5kZXJGaWVsZFdpdGhBZGRvbnMiLCJBYnN0cmFjdEZpZWxkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7Ozs7O0FBRUE7SUFDTUEsYTs7Ozs7Ozs7OztpQ0FDTztBQUFBLHlCQUMwRSxLQUFLQyxLQUQvRTtBQUFBLGdCQUNFQyxLQURGLFVBQ0VBLEtBREY7QUFBQSxnQkFDU0MsUUFEVCxVQUNTQSxRQURUO0FBQUEsZ0JBQ21CQyxZQURuQixVQUNtQkEsWUFEbkI7QUFBQSxnQkFDaUNDLEtBRGpDLFVBQ2lDQSxLQURqQztBQUFBLGdCQUN3Q0MsV0FEeEMsVUFDd0NBLFdBRHhDO0FBQUEsZ0JBQ3FEQyxPQURyRCxVQUNxREEsT0FEckQ7QUFBQSxnQkFDaUVOLEtBRGpFOzs7QUFHTCxnQkFBSU8sY0FBSjtBQUNBLGdCQUFJTixLQUFKLEVBQVc7QUFDUE0sd0JBQVE7QUFBQyxxQ0FBRDtBQUFBLHNCQUFPLFdBQVAsRUFBYSxXQUFXTCxXQUFXLFVBQVgsR0FBd0IsRUFBaEQsRUFBb0QsU0FBU0ksT0FBN0Q7QUFDSixrREFBQyxpQkFBRCwyQkFBTyxNQUFLLFVBQVosRUFBdUIsVUFBVUosUUFBakMsRUFBMkMsU0FBU0UsS0FBcEQsRUFBMkQsU0FBU0UsT0FBcEUsSUFBaUZOLEtBQWpGLEVBREk7QUFBQTtBQUM0RkM7QUFENUYsaUJBQVI7QUFHSCxhQUpELE1BSU87QUFDSE0sd0JBQVE7QUFBQyxxQ0FBRDtBQUFBLHNCQUFPLFdBQVAsRUFBYSxXQUFXTCxXQUFXLFVBQVgsR0FBd0IsRUFBaEQsRUFBb0QsU0FBU0ksT0FBN0Q7QUFDSixrREFBQyxpQkFBRCwyQkFBTyxNQUFLLFVBQVosRUFBdUIsVUFBVUosUUFBakMsRUFBMkMsU0FBU0UsS0FBcEQsRUFBMkQsU0FBU0UsT0FBcEUsSUFBaUZOLEtBQWpGO0FBREksaUJBQVI7QUFHSDs7QUFFRCxtQkFBTyxLQUFLUSxxQkFBTCxDQUEyQkQsS0FBM0IsRUFBa0NKLFlBQWxDLEVBQWdERSxXQUFoRCxDQUFQO0FBQ0g7OztFQWhCdUJJLHVCOztrQkFrQmJWLGEiLCJmaWxlIjoiQ2hlY2tib3hGaWVsZC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHtJbnB1dCwgTGFiZWx9IGZyb20gJ3JlYWN0c3RyYXAnXG5pbXBvcnQgQWJzdHJhY3RGaWVsZCBmcm9tIFwiLi9BYnN0cmFjdEZpZWxkXCI7XG5cbi8vIFRPRE8gTk9QRVBBUlRTIC0gTmVsemUgQWJzdHJhY3RGaWVsZCAvIGFkZG9ueVxuY2xhc3MgQ2hlY2tib3hGaWVsZCBleHRlbmRzIEFic3RyYWN0RmllbGQge1xuICAgIHJlbmRlcigpIHtcbiAgICAgICAgY29uc3Qge2xhYmVsLCBkaXNhYmxlZCwgYWRkb25zQmVmb3JlLCB2YWx1ZSwgYWRkb25zQWZ0ZXIsIG9uQ2xpY2ssIC4uLnByb3BzfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgbGV0IGZpZWxkO1xuICAgICAgICBpZiAobGFiZWwpIHtcbiAgICAgICAgICAgIGZpZWxkID0gPExhYmVsIGNoZWNrIGNsYXNzTmFtZT17ZGlzYWJsZWQgPyBcImRpc2FibGVkXCIgOiBcIlwifSBvbkNsaWNrPXtvbkNsaWNrfT5cbiAgICAgICAgICAgICAgICA8SW5wdXQgdHlwZT1cImNoZWNrYm94XCIgZGlzYWJsZWQ9e2Rpc2FibGVkfSBjaGVja2VkPXt2YWx1ZX0gb25DbGljaz17b25DbGlja30gey4uLnByb3BzfS8+Jm5ic3A7e2xhYmVsfVxuICAgICAgICAgICAgPC9MYWJlbD47XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBmaWVsZCA9IDxMYWJlbCBjaGVjayBjbGFzc05hbWU9e2Rpc2FibGVkID8gXCJkaXNhYmxlZFwiIDogXCJcIn0gb25DbGljaz17b25DbGlja30+XG4gICAgICAgICAgICAgICAgPElucHV0IHR5cGU9XCJjaGVja2JveFwiIGRpc2FibGVkPXtkaXNhYmxlZH0gY2hlY2tlZD17dmFsdWV9IG9uQ2xpY2s9e29uQ2xpY2t9IHsuLi5wcm9wc30vPlxuICAgICAgICAgICAgPC9MYWJlbD47XG4gICAgICAgIH1cblxuICAgICAgICByZXR1cm4gdGhpcy5yZW5kZXJGaWVsZFdpdGhBZGRvbnMoZmllbGQsIGFkZG9uc0JlZm9yZSwgYWRkb25zQWZ0ZXIpO1xuICAgIH1cbn1cbmV4cG9ydCBkZWZhdWx0IENoZWNrYm94RmllbGQ7XG4iXX0=